import { IBaseDataParser } from "../../../core/src/server/parsers/IBaseDataParser";
import { IAutoplaySettings } from "../../../core/src/server/data/IAutoplayData";


export default class AutoplayDataParser implements IBaseDataParser<IAutoplaySettings>
{
    public check(data: any): boolean {
        return data?.data?.gameData?.lineLayout;
    }

    public parse(data: any): IAutoplaySettings[] {
        const maxSpins = Math.max(...data.data.gameData.autoPlayList);
        const result: IAutoplaySettings = {
            spinPresets: data.data.gameData.autoPlayList,
            defaultSpinPreset: data.data.gameData.autoPlayDefault || 0,
            lossLimits: data.data.gameData.lossLimits || [
                Math.floor(maxSpins * 0.1),
                Math.floor(maxSpins * 0.15),
                Math.floor(maxSpins * 0.2),
                Math.floor(maxSpins * 0.25),
                Math.floor(maxSpins * 0.3),
                Math.floor(maxSpins * 0.4),
                Math.floor(maxSpins * 0.5),
                Math.floor(maxSpins * 0.75),
                Math.floor(maxSpins * 1.0),
            ],
        };
        
        return [result];
    }
}